// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useAuth } from "../../context/AuthContext";

// const API = "http://3.236.217.225:5001/api/padre/rendimiento";

// const PadreRendimiento = () => {
//   const { token } = useAuth();
//   const [estudiantes, setEstudiantes] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchRendimiento = async () => {
//       try {
//         const res = await axios.get(API, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setEstudiantes(res.data || []);
//       } catch (error) {
//         console.error("Error cargando rendimiento", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRendimiento();
//   }, [token]);

//   if (loading) return <p>Cargando rendimiento...</p>;
//   if (estudiantes.length === 0) return <p>No hay estudiantes asociados a este padre</p>;

//   return (
//     <div className="card">
//       <h2>Rendimiento académico</h2>

//       {estudiantes.map((est) => (
//         <div key={est.matricula_id} className="card-estudiante">
//           <h3>
//             {est.nombres_estudiante} {est.apellidos_estudiante}
//           </h3>

//           <p>
//             <strong>Promedio general:</strong> {est.promedio ?? "N/A"}
//           </p>

//           <table>
//             <thead>
//               <tr>
//                 <th>Materia</th>
//                 <th>Nota final</th>
//                 <th>Desempeño</th>
//               </tr>
//             </thead>
//             <tbody>
//               {est.materias && est.materias.length > 0 ? (
//                 est.materias.map((mat, idx) => (
//                   <tr key={`${est.matricula_id}-${mat.materia_id}-${idx}`}>
//                     <td>{mat.nombre_materia}</td>
//                     <td>{mat.nota_final ?? "N/A"}</td>
//                     <td>{mat.desempeno ?? "N/A"}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="3">Sin notas registradas</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default PadreRendimiento;


//


import React, { useEffect, useState } from "react";
// 1. Usamos la instancia centralizada para seguridad y baseURL
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import "../../style/PadreDashboard.css"; 

const PadreRendimiento = () => {
  const { token } = useAuth();
  const [estudiantes, setEstudiantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRendimiento = async () => {
      if (!token) return;
      
      try {
        setLoading(true);
        setError("");
        // 2. Ruta relativa: axiosAuth ya apunta a http://3.236.217.225/api
        const res = await axios.get("/padre/rendimiento");
        setEstudiantes(res.data || []);
      } catch (error) {
        console.error("❌ Error cargando rendimiento:", error);
        setError("No se pudo cargar el resumen de rendimiento.");
      } finally {
        setLoading(false);
      }
    };

    fetchRendimiento();
  }, [token]);

  if (loading) return <div className="loader">⏳ Analizando promedios...</div>;
  
  if (error) return <p className="error-msg">{error}</p>;

  if (estudiantes.length === 0) {
    return <p className="no-data">No hay información académica disponible para sus acudidos.</p>;
  }

  return (
    <div className="padre-dashboard">
      <header className="padre-header">
        <h2 className="padre-title">📊 Rendimiento Académico General</h2>
        <p className="padre-subtitle">Resumen consolidado de notas por estudiante</p>
      </header>

      <div className="grid-notas">
        {estudiantes.map((est) => (
          <div key={est.matricula_id} className="padre-card" style={{ marginBottom: "25px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "2px solid #f1f5f9", marginBottom: "15px", paddingBottom: "10px" }}>
              <h3 style={{ margin: 0, color: "#1e293b" }}>
                {est.nombres_estudiante} {est.apellidos_estudiante}
              </h3>
              <div className="promedio-badge" style={{ 
                background: est.promedio < 3 ? "#fee2e2" : "#dcfce7",
                color: est.promedio < 3 ? "#ef4444" : "#22c55e",
                padding: "5px 12px",
                borderRadius: "20px",
                fontWeight: "bold"
              }}>
                Promedio: {est.promedio ? Number(est.promedio).toFixed(2) : "N/A"}
              </div>
            </div>

            <div className="tabla-container">
              <table className="tabla-excusas">
                <thead>
                  <tr>
                    <th>Materia</th>
                    <th style={{ textAlign: "center" }}>Nota Final</th>
                    <th>Desempeño</th>
                  </tr>
                </thead>
                <tbody>
                  {est.materias && est.materias.length > 0 ? (
                    est.materias.map((mat, idx) => (
                      <tr key={`${est.matricula_id}-${mat.materia_id}-${idx}`}>
                        <td><strong>{mat.nombre_materia}</strong></td>
                        <td style={{ 
                          textAlign: "center", 
                          fontWeight: "bold",
                          color: mat.nota_final < 3 ? "#e11d48" : "#2563eb"
                        }}>
                          {mat.nota_final ?? "—"}
                        </td>
                        <td>
                          <span className={`badge-status ${mat.desempeno?.toLowerCase()}`}>
                            {mat.desempeno || "Sin calificar"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center", padding: "20px", color: "#64748b" }}>
                        Sin notas registradas en este periodo.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PadreRendimiento;